import React from 'react'
import styles from './OreMultiSelect.module.css'

interface OreMultiSelectTagProps {
  value: string
  label: string
  onRemove: (value: string) => void
  truncate?: boolean
  className?: string
  style?: React.CSSProperties
  spanRef?: React.Ref<HTMLSpanElement>
}

export const OreMultiSelectTag: React.FC<OreMultiSelectTagProps> = ({ value, label, onRemove, truncate, className, style, spanRef }) => {
  return (
    <span
      ref={spanRef}
      className={`${styles['ore-multiselect__tag']} ${truncate ? styles['ore-multiselect__tag--truncate'] : ''} ${className || ''}`}
      style={style}
      title={label}
    >
      <span className={styles['ore-multiselect__tag-label']}>{label}</span>
      <button
        type="button"
        onClick={e => {
          e.stopPropagation()
          onRemove(value)
        }}
        className={styles['ore-multiselect__tag-remove']}
        aria-label={`Quitar ${label}`}
      >
        ×
      </button>
    </span>
  )
}
